import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
export const useDewasListModel = defineStore(
    'dewasListModel',
    () => {
        function convertColumnName(name, columns) {
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        function convertArrayElements(arr, columns) {
            return _.map(arr, element => {
                if (_.isArray(element)) {
                    return convertArrayElements(element, columns);
                } else if (_.isString(element)) {
                    return convertColumnName(element, columns);
                }
                return element;
            });
        }



        
       async function dewasListArray(filter = null, sort = null){
        let params = {};
        params.sort = JSON.stringify(sort);
        params.filter = JSON.stringify(filter);
        const response = await axios.get(`${API_BASE_URL}/customstore-dewas`, {
            params: params,
            headers: {
                Authorization: api.defaults.headers.common['Authorization'],
                'Content-Type': 'application/json',
            },
        });
        if (response.data) {
            return {
                data: response.data.data,
                totalCount: response.data.totalCount,
            };
        }
        throw 'Data loading error';
        
       }

       function convertArrayTgl(loadArray) {
            
        _.forEach(loadArray, (item, index) => {
            if(item instanceof Date){
                 loadArray[index]= formatDateToISOString(item);
            }
            
          });

          return loadArray;
    }


       async function dewasListUpdate(key = null, values = null){   
        values = convertArrayTgl(values);
               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-dewas/insert`, {values : values, id : key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Insert error:', error);
                return error.response.data;
                // throw JSON.stringify(error.response.data.message, null, 2);
         
            }
        
       }

       async function dewasListDelete(key){
               try {
                const response = await axios.delete(`${API_BASE_URL}/customstore-dewas/${key}`, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data;
                }
            } catch (error) {
                console.error('Delete error:', error);
                return error.response.data;
                // throw JSON.stringify(error.response.data.message, null, 2);
         
            }
        
       }




        const dewasListCustomStore = new CustomStore({
            key: 'dewas_id',
            update: (key, values) => {
                console.log("debug MASUK UPDATE dewascustomstore", key, values)
            },
            load: async (loadOptions) => {
                const columns = ['dewas', 'status_aktifs', 'jabatans'];
                let params = {};
                params.sort = "";params.filter="";
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));

                
                }
               
                
                if (loadOptions.filter) {
                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);

                }


               // ================FILTER DEFAULT --> filter dewas yang aktif
                loadOptions.filterDefault = [];
                if(params.filter === ""){
                    // loadOptions.filterDefault = [['dewas.is_dewas', '=', true],'and',['dewas.status_aktif_id', '=', '1']];
                    loadOptions.filterDefault = ['dewas.status_aktif_id', '=', '1'];
                }
                // else{
                //     loadOptions.filterDefault = ['dewas.is_dewas', '=', true];
                // }
               
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }

                const hasOnlyTableId = loadOptions.sort && loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'dewas_id';
            
               
                if(params.sort === "" || hasOnlyTableId){
                    // loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                    // loadOptions.sortDefault.push({"selector":"nik","desc":false});
                    // loadOptions.sortDefault.push({"selector":"pegawai_statuses.id","desc":false});
                    // loadOptions.sortDefault.push({"selector":"tgl_mulai_bekerja","desc":false});
                    loadOptions.sortDefault.push({"selector":"nama","desc":false});
                    params.sort = "";
                }
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-dewas`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
        
          
              
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                    };
                }

                throw 'Data loading error';
            },
        });





          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'tgl_mulai_bekerja') || _.includes(item, 'tgl_lahir') || _.includes(item, 'pensiun_tgl')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }

        



        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            dewasListCustomStore,
            dewasListArray,
            dewasListUpdate,
            dewasListDelete
           
        }
    });